import { ApiMcpServerService } from '.';
import { AxiosResponse } from 'axios';
import { HttpMethods } from '../httpMethods';
import { Controllers } from '../../utils/constants';
import { BaseService } from '../baseService';
import { McpServerDto, McpServerTestConnectionDto } from 'src/types/mcpServer';

export class McpServerService extends BaseService implements ApiMcpServerService {
    async getMcpServers(urlParams: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.McpServer, '', urlParams);
    }

    async getMcpServerById(id: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.McpServer, id);
    }

    async createMcpServer(data: McpServerDto): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.McpServer, 'create', '', data);
    }

    async updateMcpServer(id: string, data: McpServerDto): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.McpServer, `update/${id}`, '', data);
    }

    async deleteMcpServers(ids: string[]): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.McpServer, 'delete', '', ids);
    }

    async testConnection(id: string, data: McpServerTestConnectionDto): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.McpServer, `${id}/test-connection`, '', data);
    }

    async getCredential(id: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.McpServer, `${id}/credential`);
    }
}
